import { render, staticRenderFns } from "./StrukturOrganisasiNew.vue?vue&type=template&id=946fef02&scoped=true"
import script from "./StrukturOrganisasiNew.vue?vue&type=script&lang=js"
export * from "./StrukturOrganisasiNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946fef02",
  null
  
)

export default component.exports